import PropTypes from 'prop-types';
import React from 'react';
import Link from '@utility/Link';
import ScrollInView from '@utility/ScrollInView';
import * as styles from './styles.module.scss';

const FeaturedModules = ({ data: { title, links, columns } }) => (
  <div>
    <ScrollInView>
      <div className="wrapper">
        <div className="grid grid-cols-2">
          <h2
            className={`mb-12 md:mb-20 type-sans-530 md:type-sans-630 ${
              columns === 2 ? styles.half : styles.full
            }`}
          >
            {title}
          </h2>
          <div
            className={`grid grid-cols-12 ${
              columns === 2 ? styles.half : styles.full
            } ${styles['gap' + columns]}`}
          >
            {links &&
              links.map((link) => (
                <div key={link._key} className={styles['pack' + columns]}>
                  <div className={`${styles.card} md-down:mb-10 md:w-[275px]`}>
                    <div
                      style={{
                        backgroundImage: `url(${link?.bgImage?.asset?.url})`,
                      }}
                      className={`bg-cover ${styles.square}`}
                    >
                      <div className={`${styles.innerSquare}`}>
                        <img
                          src={link?.iconImage?.asset?.url}
                          className="w-[50%] md:w-[40%]"
                          alt={link?.iconImage?.altText || ''}
                        />
                      </div>
                    </div>
                    <h3 className="type-sans-240  md:w-[80%]">
                      {link.link ? (
                        <Link
                          to={link.link}
                          className={styles.cardLink}
                          styled={false}
                          aria-label={link.title}
                          // internalExternal
                        >
                          {link.title}
                        </Link>
                      ) : (
                        <p>{link.title}</p>
                      )}
                    </h3>
                    {link.copy && (
                      <p className="type-sans-230 md:w-[80%]">{link.copy}</p>
                    )}
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </ScrollInView>
  </div>
);

FeaturedModules.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    links: PropTypes.arrayOf(PropTypes.object).isRequired,
    columns: PropTypes.number.isRequired,
  }),
};

FeaturedModules.defaultProps = {
  data: {
    title: '',
    links: [],
    columns: 3,
  },
};

export default FeaturedModules;
